import AppLoader from '@/components/AppLoader';
import Header from '@/components/header';
import { AuthProvider } from '@/context/AuthContextProvider';
import { SearchWidgetProvider } from '@/context/SearchWidgetContextProvider';
import { BookingExpiryProvider } from '@/contexts/BookingExpiryContext';
import { cn } from '@/utils/cn';
import { GTM_EVENT, trackCustomEvent } from '@/utils/gtm';
import { getPageType, getSiteEnvironment } from '@/utils/gtmPayloads';
import i18n from 'i18next';
import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

function App() {
  const location = useLocation();
  const previousUrlRef = useRef<string>();

  useEffect(() => {
    const currentUrl = window.location.href;

    // The initial document load is covered by the pre-container base push in
    // main.tsx; virtual_page_view covers SPA navigations only (BR-57983).
    if (previousUrlRef.current !== undefined) {
      trackCustomEvent(GTM_EVENT.VIRTUAL_PAGE_VIEW, {
        current_page_refferer_url: previousUrlRef.current, // (sic) spec spelling
        current_page_url: currentUrl,
        current_page_title: document.title,
        page_type: getPageType(location.pathname),
        page_language: i18n.language,
        site_environment: getSiteEnvironment(),
      });
    }

    previousUrlRef.current = currentUrl;
  }, [location.pathname]);

  return (
    <AppLoader>
      <AuthProvider>
        <SearchWidgetProvider>
          <BookingExpiryProvider>
            <div className="flex min-h-screen min-w-mobile flex-col">
              <ToastContainer
                position="top-center"
                theme="colored"
                pauseOnFocusLoss={false}
                pauseOnHover={false}
                hideProgressBar
              />
              <Header />
              <main className="flex w-full flex-1">
                <div
                  className={cn('w-full', {
                    'flex flex-1': location.pathname.startsWith('/account'),
                  })}
                >
                  <Outlet />
                </div>
              </main>
            </div>
          </BookingExpiryProvider>
        </SearchWidgetProvider>
      </AuthProvider>
    </AppLoader>
  );
}

export default App;
